
import { Component, Vue } from "vue-property-decorator";
import _ from "lodash-es";
import Loading from "../../components/loading.vue";
import BluePop from "@/views/ai-builder/components/blue-pop.vue";

import ModalTitle from "@/lib/model/exam/modal-title";
import MessageDialog from "./components/message-dialog-new.vue";
import EmailDialog from "./components/email-dialog-new.vue";
import { TemplateNew } from "@/lib/model/template/template-new";

class ExportStatus {
  label = "";
  value = 0;
}

class PageSizeOptions {
  value = 10;
}
class ExamItem {
  id = 0;
  name = "";
  remark = "";
  isEnableAi = true;
  examTypeFlag = true;
}

@Component({
  components: {
    Loading,
    MessageDialog,
    BluePop,
    EmailDialog
  }
})
export default class MessageList extends Vue {
  name = "export-list";
  tableLoading = false;
  page = 1;
  currentPageSize = 10;
  total = 0;
  loadingList = true;
  modalTitle: ModalTitle = new ModalTitle();
  examId = 0;
  pageType = 1; //短信 or 邮件
  tId = 0;
  onlyShow = false;
  pageSizeOptions: PageSizeOptions[] = [
    { value: 10 },
    { value: 20 },
    { value: 50 },
    { value: 100 }
  ];
  exportStatus: ExportStatus[] = [
    { label: "默认", value: 0 },
    { label: "执行中", value: 1 },
    { label: "成功", value: 2 },
    { label: "失败", value: 3 }
  ];

  rowStyle = {
    color: "#8B8F94",
    "font-weight": "400",
    "font-size": "14px"
  };
  list: any[] = [];

  listParam: any = {};
  candidateTag = [];
  examAll: ExamItem[] = new Array<ExamItem>();

  nameLike = "";

  showMessageDialog = false;
  showEmailDialog = false;
  showMessageDelDialog = false;

  created() {
    this.examId = Number(this.$route?.query?.toExamId || 0);
    this.listParam.auditStatus = 999;
    if (
      this.$route?.query &&
      this.$route?.query.env &&
      this.$route?.query.tem
    ) {
      this.listParam.env = +this.$route?.query.env;
      this.pageType = +this.$route?.query.tem;
    } else {
      this.listParam.env = 0;
    }

    this.getTemplateList();
  }

  switchType(i: number) {
    this.pageType = i;
    this.getTemplateList("toFirst");
  }
  back() {
    this.$router.push("/message-comp/list");
  }
  addTemp() {
    this.tId = 0;
    this.onlyShow = false;
    if (this.pageType === 1) {
      this.showMessageDialog = true;
    } else {
      this.showEmailDialog = true;
    }
  }
  cancelMessage() {
    this.showMessageDialog = false;
  }
  saveMessage() {
    this.$message.success("提交成功");
    this.showMessageDialog = false;
    this.getTemplateList();
  }
  cancelE() {
    this.showEmailDialog = false;
  }
  saveE() {
    this.$message.success("提交成功");
    this.showEmailDialog = false;
    this.getTemplateList();
  }
  //编辑弹窗
  eidt(row: any, onlyShow = false) {
    this.tId = row.templateId;
    this.onlyShow = onlyShow;
    if (this.pageType === 1) {
      this.showMessageDialog = true;
    } else {
      this.showEmailDialog = true;
    }
  }
  //删除弹窗
  del(row: any) {
    this.tId = row.templateId;
    this.showMessageDelDialog = true;
  }
  delTemp() {
    TemplateNew.delete(this.tId).then(res => {
      if (res.code === 0) {
        this.$message.success("删除成功");
        this.showMessageDelDialog = false;
        this.getTemplateList();
      }
    });
  }

  //加载模板列表
  getTemplateList(flag?: string) {
    if (flag === "toFirst") {
      this.page = 1;
      this.listParam.page = this.page;
    }
    this.loadingList = true;
    this.listParam.type = this.pageType; // 1 2

    const param = JSON.parse(JSON.stringify(this.listParam));
    param.auditStatusList =
      param.auditStatus === 999 ? [] : [param.auditStatus]; //模板状态 要数组的
    param.nameLike = this.nameLike;

    TemplateNew.getList(param)
      .then(res => {
        this.total = res.data.count;
        this.tableLoading = false;
        this.loadingList = false;
        this.list = res.data.list;
      })
      .finally(() => {
        //
      });
  }
}
